var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOutputLogo180X180 = function SvgOutputLogo180X180(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 27,
    viewBox: "0 0 46 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0667 24.3L32.926 2.69995H25.4902L2.70605 24.2254L2.78493 24.3H10.0667Z",
    fill: "#92FFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5179 24.3L43.3734 2.69995H35.9414L13.1572 24.2254L13.2361 24.3H20.5179Z",
    fill: "#92FFDD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOutputLogo180X180);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/output-logo-180x180.ff036b324a58b6e7ed9d7baf73a86fcf.svg";